import { shape, string } from "prop-types";
import React, { useState } from "react";

//Hooks
import { useUserContext } from "@magento/peregrine/lib/context/user";
import { useIntl } from "react-intl";
import { useNavigation } from "../../../peregrine/talons/Navigation/useNavigation";

//Style
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import UIkit from "uikit";
import defaultClasses from "./navigation.module.scss";

//Components
import { Link, resourceUrl, useHistory } from "@magento/venia-ui/lib/drivers";
import { FormattedMessage } from "react-intl";
import Icon from "../../../../components/Icon";
import Image from "../Image";
import NavHeader from "./navHeader";

//Asset
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
import img_placeholder from "../../../../assets/images/area-personale/icone/Pacchero.jpg";
import LinkBetween from "../../../../components/LinkBetween/LinkBetween";
import { SocialLinks } from "../Header/headerDesktop";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
import { isExternalLink } from "@Src_main/utils/generalUtils";
import WeglotInit from "@overrides_venia/venia-ui/components/WeglotInit/weglotInit";
var isDefaultMenu = true;
var isTakeawayMenu = false;
var Navigation = props => {
  var [isMenuOpen, setMenuOpen] = useState(false);
  var [isSubMenu2Open, setIsSubMenu2Open] = useState(false);
  var [isSubMenu3Open, setIsSubMenu3Open] = useState(false);
  var {
    handleBack,
    handleClose,
    hasModal,
    isOpen,
    isTopLevel,
    view
  } = useNavigation();
  var [{
    isPageLoading
  }] = useAppContext();
  if (isOrderActive) {
    isTakeawayMenu = true;
    isDefaultMenu = false;
  }
  var closeSubMenu = () => {
    setMenuOpen(false);
    setIsSubMenu2Open(false);
    setIsSubMenu3Open(false);
  };
  var [{
    isSignedIn,
    currentUser
  }] = useUserContext();
  var goToRegistration = () => {
    handleClose();
    try {
      UIkit.offcanvas("#offcanvas-login-dx").show();
    } catch (error) {
      console.error(error);
    }
  };
  var handleCloseSubMenu = () => {
    handleClose();
    setMenuOpen(false);
    setIsSubMenu2Open(false);
    setIsSubMenu3Open(false);
  };
  var classes = mergeClasses(defaultClasses, props.classes);
  var rootClassName = isOpen ? classes.root_open : classes.root;
  var bodyClassName = hasModal ? classes.body_masked : classes.body;
  var isSubMenuOpen = isMenuOpen == true || isSubMenu2Open == true || isSubMenu3Open == true;
  var {
    formatMessage
  } = useIntl();
  var MenuItem = _ref => {
    var {
      to,
      onClick,
      id,
      defaultMessage
    } = _ref;
    return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
      to: to,
      onClick: onClick
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: id,
      defaultMessage: defaultMessage
    }))));
  };
  var subMenuDefaultItems2 = [{
    id: "url.key.our.challenge",
    titleId: "header.menu.sfida.title",
    defaultMessage: "La nostra sfida"
  }, {
    id: "url.key.our.partners",
    titleId: "header.menu.produttori.title",
    defaultMessage: "Produttori"
  }];
  var subMenuDefault2 = /*#__PURE__*/React.createElement("div", {
    className: "uk-animation-fade ".concat(classes.contentSub)
  }, /*#__PURE__*/React.createElement("div", {
    className: bodyClassName
  }, /*#__PURE__*/React.createElement("ul", {
    className: "uk-list menu-tree menu-default menu-submenu"
  }, subMenuDefaultItems2.map(item => /*#__PURE__*/React.createElement(MenuItem, {
    key: item.id,
    to: resourceUrl(formatMessage({
      id: item.id
    })),
    onClick: handleCloseSubMenu,
    id: item.titleId,
    defaultMessage: item.defaultMessage
  })))));
  var subMenuDefaultItems3 = [{
    id: "url.key.our.path",
    defaultMessage: "Il nostro percorso",
    titleId: "header.menu.nostro_percorso.title"
  }, {
    id: "url.key.blog",
    defaultMessage: "Giornale",
    titleId: "header.menu.giornale.title"
  }];
  var subMenuDefault3 = /*#__PURE__*/React.createElement("div", {
    className: "uk-animation-fade uk-animation-fade ".concat(classes.contentSub)
  }, /*#__PURE__*/React.createElement("div", {
    className: bodyClassName
  }, /*#__PURE__*/React.createElement("ul", {
    className: "uk-list menu-tree menu-default menu-submenu"
  }, subMenuDefaultItems3.map(item => /*#__PURE__*/React.createElement(MenuItem, {
    key: item.id,
    to: resourceUrl(formatMessage({
      id: item.id
    })),
    onClick: handleCloseSubMenu,
    id: item.titleId,
    defaultMessage: item.defaultMessage
  })))));
  var goBack = /*#__PURE__*/React.createElement("div", {
    className: "uk-animation-fade uk-flex ".concat(classes.closeSubMenu),
    onClick: closeSubMenu
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-arrow-left",
    color: "white",
    isCircled: true
  }), /*#__PURE__*/React.createElement("span", {
    className: "uk-text-uppercase"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "button.indietro"
  })));
  var MainMenuItem = _ref2 => {
    var {
      href,
      onClick,
      id
    } = _ref2;
    var history = useHistory();
    var handleClick = e => {
      if (onClick) {
        onClick(e);
      } else if (!isExternalLink(href)) {
        e.preventDefault();
        handleClose();
        history.push(href);
      }
    };
    return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      href: href,
      onClick: handleClick,
      className: "menu-item"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: id
    }))));
  };
  var mainMenuItems = [{
    id: "header.menu.menu.title",
    href: formatMessage({
      id: "url.key.restaurant.menu"
    })
  }, {
    id: "header.menu.ristoranti.title",
    href: formatMessage({
      id: "url.key.restaurants"
    })
  }, {
    id: "header.menu.lavora_con_noi.title",
    href: formatMessage({
      id: "url.key.work.with.us"
    })
  }, {
    id: "header.menu.eventi.title",
    href: formatMessage({
      id: "url.key.events"
    })
  }, WEBSITE_CODE === "MSCIT" ? {
    id: "header.cena.cantata.title",
    href: formatMessage({
      id: "url.key.eventbrite.cene.cantate"
    })
  } : null, WEBSITE_CODE === "MSCIT" ? {
    id: "header.menu.chi.title",
    onClick: () => setIsSubMenu3Open(true),
    href: "#"
  } : null, WEBSITE_CODE === "MSCUK" ? {
    id: "header.menu.chi.title",
    href: "https://www.miscusi.com"
  } : null].filter(Boolean);
  var menuDefault = /*#__PURE__*/React.createElement("ul", {
    className: "uk-list menu-tree menu-default"
  }, mainMenuItems.map((item, index) => /*#__PURE__*/React.createElement(MainMenuItem, {
    key: index,
    href: item.href || formatMessage({
      id: item.id
    }),
    onClick: item.onClick,
    id: item.id
  })));
  var imageAvatar = currentUser !== null && currentUser !== void 0 && currentUser.avatar ? currentUser.avatar.image : img_placeholder;
  if (isPageLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement("aside", {
    className: "".concat(rootClassName, " ").concat(classes.sideMenu)
  }, /*#__PURE__*/React.createElement("header", {
    className: "".concat(classes.header)
  }, /*#__PURE__*/React.createElement(WeglotInit, {
    location: "navigation"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, isSubMenuOpen ? goBack : null), /*#__PURE__*/React.createElement(NavHeader, {
    isTopLevel: isTopLevel,
    onBack: handleBack,
    view: view
  })), isSubMenuOpen ? null : /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, isSignedIn ? /*#__PURE__*/React.createElement(Link, {
    to: resourceUrl(formatMessage({
      id: "url.key.myaccount"
    })),
    className: "user-box uk-flex uk-flex-middle",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "user",
    src: imageAvatar,
    height: "64",
    width: "64",
    displayPlaceholder: false
  }), /*#__PURE__*/React.createElement("div", {
    className: "name uk-text-uppercase weglotExclude"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "header.login.welcome_mobile"
  }), ",", /*#__PURE__*/React.createElement("br", null), currentUser.firstname ? currentUser.firstname : currentUser.email, "!")) : /*#__PURE__*/React.createElement(Link, {
    to: resourceUrl("#"),
    className: "user-box uk-flex uk-flex-middle",
    onClick: goToRegistration
  }, /*#__PURE__*/React.createElement("div", {
    className: "image"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-person",
    color: "red"
  })), /*#__PURE__*/React.createElement("div", {
    className: "name uk-text-uppercase weglotExclude"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "header.login.ciao"
  }), "!", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "header.login.accedi"
  })))), /*#__PURE__*/React.createElement("div", {
    className: bodyClassName
  }, (isDefaultMenu || isTakeawayMenu) && menuDefault, /*#__PURE__*/React.createElement("ul", {
    className: "uk-list menu-tree menu-secondary"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(LinkBetween, {
    href: "#",
    onClick: () => {
      setIsSubMenu2Open(true);
    },
    className: "menu-item"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "header.menu.mangiare_bene.title"
  })))), !isTakeawayMenu ? /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(LinkBetween, {
    toTakeAway: false,
    href: formatMessage({
      id: "url.key.ti_serve_aiuto"
    }),
    onClick: handleClose,
    className: "menu-item"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "header.menu.ti_serve_aiuto.title"
  }))) : null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(LinkBetween, {
    toTakeAway: false,
    href: formatMessage({
      id: "url.key.loyalty"
    }),
    onClick: handleClose,
    className: "menu-item"
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "header.menu.loyalty.title"
  })))), isDefaultMenu ? null : /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(LinkBetween, {
    toTakeAway: false,
    href: "/",
    onClick: handleClose,
    className: "menu-item"
  }, /*#__PURE__*/React.createElement("span", null, "Miscusi.com")))), /*#__PURE__*/React.createElement("div", {
    className: "menu-footer uk-flex uk-flex-middle"
  }, /*#__PURE__*/React.createElement(SocialLinks, {
    classes: {
      socials: "uk-flex uk-flex-center uk-padding-medium-bottom"
    }
  })))), isMenuOpen && WEBSITE_CODE !== "MSCUK" ? subMenuDefault1 : null, isSubMenu2Open ? subMenuDefault2 : null, isSubMenu3Open ? subMenuDefault3 : null);
};
export default Navigation;
Navigation.propTypes = {
  classes: shape({
    body: string,
    form_closed: string,
    form_open: string,
    header: string,
    content: string,
    footer: string,
    root: string,
    root_open: string,
    signIn_closed: string,
    signIn_open: string,
    sideMenu: string
  })
};